module.exports = __webpack_public_path__ + "static/img/ebiz-logo.299bd70.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ebiz-logo.jpg
// module id = tj1y
// module chunks = 0